import Vue from "vue";
import VueRouter from "vue-router";
// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";
import auth from "./routes/auth";
import profile from "./routes/profile";
import users from "./routes/users";
import semesters from "./routes/semesters";
import courses from "./routes/courses";
import sessions from "./routes/sessions";
import exercises from "./routes/exercises";
import events from "./routes/events";
import comments from "./routes/comments";
import faqs from "./routes/faqs";
import invoices from "./routes/invoices";
import others from "./routes/others";
import store from "@/store";
import notifications from "./routes/notifications";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  stringifyQuery(query) {
    var result = require("qs").stringify(query, {
      encode: false,
      arrayFormat: "indices",
      skipNulls: true,
      sort: (a, b) => a.localeCompare(b),
    });
    return result ? "?" + result : "";
  },
  parseQuery(query) {
    var result = require("qs").parse(query);
    if (result.attributes) {
      var tempAttr = require("qs").parse(result.attributes);
      var attributes = [];
      Object.keys(tempAttr).forEach((key) => {
        attributes["attributes[" + key + "]"] = tempAttr[key];
      });
      result.attributes = undefined;
      result = { ...result, ...attributes };
    }
    return result;
  },
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/" },
    ...auth,
    ...profile,
    ...users,
    ...semesters,
    ...sessions,
    ...courses,
    ...exercises,
    ...events,
    ...others,
    ...comments,
    ...faqs,
    ...invoices,
    ...notifications,

    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  try {
    let isAdmin =
      store.state.auth.userData && store.state.auth.userData.permissions
        ? store.state.auth.userData.permissions.permissions.length > 0
        : getUserData() &&
          getUserData().permissions &&
          getUserData().permissions.permissions
        ? getUserData().permissions.permissions.length > 0
        : false;
    let userData =
      store.state.auth.userData && Object.keys(store.state.auth.userData).length
        ? store.state.auth.userData
        : getUserData();
    const regExp = /^[\u0600-\u06FF\s]+$/;

    const isLoggedIn = isUserLoggedIn();

    if (isLoggedIn) {
      if (to.path == "/" && isAdmin) {
        return next("/dashboard");
      }
      if (!isAdmin) {
        if (to.path == "/") {
          if (userData.first_name && userData.last_name) {
            const validFirstName = !regExp.test(userData.last_name);
            const validLastName = !regExp.test(userData.last_name);
            if (validFirstName || validLastName) {
              Vue.swal({
                icon: "warning",
                text: "لطفا برای ادامه کار با سیستم نام و نام خانوادگی خود را فارسی وارد کنید!",
                showCancelButton: false,
                showConfirmButton: false,
                buttonsStyling: false,
              });
              return next("/profile/edit");
            } else {
              return next("/profile/road-map");
            }
          } else {
            Vue.swal({
              icon: "warning",
              text: "لطفا برای ادامه کار با سیستم نام و نام خانوادگی خود را فارسی وارد کنید!",
              showCancelButton: false,
              showConfirmButton: false,
              buttonsStyling: false,
            });
            return next("/profile/edit");
          }
        } else if (to.path != "/profile/edit") {
          if (userData.first_name && userData.last_name) {
            const validFirstName = !regExp.test(userData.last_name);
            const validLastName = !regExp.test(userData.last_name);
            if (validFirstName || validLastName) {
              Vue.swal({
                icon: "warning",
                text: "لطفا برای ادامه کار با سیستم نام و نام خانوادگی خود را فارسی وارد کنید!",
                showCancelButton: false,
                showConfirmButton: false,
                buttonsStyling: false,
              });
              return next("/profile/edit");
            } else {
              return next();
            }
          } else {
            Vue.swal({
              icon: "warning",
              text: "لطفا برای ادامه کار با سیستم نام و نام خانوادگی خود را فارسی وارد کنید!",
              showCancelButton: false,
              showConfirmButton: false,
              buttonsStyling: false,
            });
            return next("/profile/edit");
          }
        } else {
          if (userData.first_name && userData.last_name) {
            const validFirstName = !regExp.test(userData.last_name);
            const validLastName = !regExp.test(userData.last_name);
            if (validFirstName || validLastName) {
              Vue.swal({
                icon: "warning",
                text: "لطفا برای ادامه کار با سیستم نام و نام خانوادگی خود را فارسی وارد کنید!",
                showCancelButton: false,
                showConfirmButton: false,
                buttonsStyling: false,
              });
            }
          } else {
            Vue.swal({
              icon: "warning",
              text: "لطفا برای ادامه کار با سیستم نام و نام خانوادگی خود را فارسی وارد کنید!",
              showCancelButton: false,
              showConfirmButton: false,
              buttonsStyling: false,
            });
          }
        }
      }
      if (to.meta.hasPermission && !isAdmin) {
        return next("/profile");
      }
      if (to.meta.redirectIfLoggedIn) {
        return next("/dashboard");
      }
    }
    if (!to.meta.redirectIfLoggedIn && !isLoggedIn && !to.meta.notNeedLogin) {
      return next({ name: "auth-login" });
    }

    return next();
    // if (to.meta.redirectIfLoggedIn && isLoggedIn && to.hasPermission &&  hasPermission) {
    //   return next();

    // }
    // if (!to.meta.redirectIfLoggedIn && !isLoggedIn && !to.meta.notNeedLogin) {
    //   return next({ name: "auth-login" });
    // }

    //   return next("/");
  } catch (err) {}
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
